import { ModelSetTransformer, ModelTransformer } from '../common/common.model';

export interface ExtManagementEffectivenessItem {
    displayOrder: number;
    metricID: number;
    metricName: string;
    managerID: number;
    score: number;
    target: number;
}

export interface ExtManagementEffectivenessProgress {
    score: number;
    webColour: string;
}

export interface ExtManagementEffectiveness {
    gridEntries: ExtManagementEffectivenessItem[];
    progressBarData: ExtManagementEffectivenessProgress;
}

export interface ManagementEffectivenessProgress {
    score: number;
    color: string;
}

export interface ManagementEffectivenessItem {
    metricName: string;
    score: number;
    target: number;
}

export interface ManagementEffectiveness {
    progress: ManagementEffectivenessProgress;
    items: ManagementEffectivenessItem[];
}

class ManagementEffectivenessItemModelTransformer
    implements
        ModelTransformer<
            ManagementEffectivenessItem,
            ExtManagementEffectivenessItem
        >
{
    transform(
        model: ExtManagementEffectivenessItem,
    ): ManagementEffectivenessItem {
        return {
            metricName: model.metricName,
            score: model.score,
            target: model.target,
        };
    }
}

class ManagementEffectivenessItemModelSetTransformer extends ModelSetTransformer<
    ManagementEffectivenessItem,
    ExtManagementEffectivenessItem
> {
    protected newTransformer(): ModelTransformer<
        ManagementEffectivenessItem,
        ExtManagementEffectivenessItem
    > {
        return new ManagementEffectivenessItemModelTransformer();
    }

    transform(
        model: ExtManagementEffectivenessItem[],
    ): ManagementEffectivenessItem[] {
        return super.transform(
            model.sort((a, b) => a.displayOrder - b.displayOrder),
        );
    }
}

class ManagementEffectivenessProgressModelTransformer
    implements
        ModelTransformer<
            ManagementEffectivenessProgress,
            ExtManagementEffectivenessProgress
        >
{
    transform(
        model: ExtManagementEffectivenessProgress,
    ): ManagementEffectivenessProgress {
        return {
            score: model.score,
            color: model.webColour,
        };
    }
}

export class ManagementEffectivenessModelTransformer
    implements
        ModelTransformer<ManagementEffectiveness, ExtManagementEffectiveness>
{
    transform(model: ExtManagementEffectiveness): ManagementEffectiveness {
        const items =
            new ManagementEffectivenessItemModelSetTransformer().transform(
                model.gridEntries,
            );
        const progress =
            new ManagementEffectivenessProgressModelTransformer().transform(
                model.progressBarData,
            );
        return {
            progress,
            items,
        };
    }
}

export function validateManagementEffectiveness(
    model: ManagementEffectiveness,
): void {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    const valid =
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        model != null &&
        model.progress != null &&
        model.items != null &&
        model.items.length !== 0;
    if (!valid) {
        throw new Error('ManagementEffectiveness not valid');
    }
}
